/* tslint:disable */
/* eslint-disable */
/* @relayHash dfee2add9dc16b8799c6dfd49ca756c9 */

import { ConcreteRequest } from "relay-runtime";
export type userGeoInfoQueryVariables = {
    cookieDomain?: string | null;
};
export type userGeoInfoQueryResponse = {
    readonly viewer: {
        readonly regionalInfo: ReadonlyArray<{
            readonly countryCode: string | null;
            readonly zipCode: string | null;
            readonly regionsByZipCode: ReadonlyArray<{
                readonly displayName: string | null;
                readonly urlLabel: string | null;
            } | null> | null;
            readonly incomeLevel: {
                readonly incomeBracket: string | null;
                readonly incomePercentile: string | null;
            } | null;
        } | null> | null;
    };
};
export type userGeoInfoQuery = {
    readonly response: userGeoInfoQueryResponse;
    readonly variables: userGeoInfoQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "cookieDomain"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cookieDomain",
    "variableName": "cookieDomain"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipCode",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "RegionsByZipCode",
  "kind": "LinkedField",
  "name": "regionsByZipCode",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlLabel",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "IncomeLevel",
  "kind": "LinkedField",
  "name": "incomeLevel",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incomeBracket",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incomePercentile",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userGeoInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "RegionalInfo",
            "kind": "LinkedField",
            "name": "regionalInfo",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userGeoInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "RegionalInfo",
            "kind": "LinkedField",
            "name": "regionalInfo",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/326.0.0-2021-08-03T13:35:11.447Z/userGeoInfoQuery",
    "metadata": {},
    "name": "userGeoInfoQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = 'e6138f9b26fdee1965d718f268caa693';
export default node;
